import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        close: '&',
        companyTerms: '='
    },
    template: `
        <div class="modal-header">
            <h2>{{ 'user.Activate account' | translate }}</h2>
        </div>
        <form ng-submit="vm.save()">
            <div class="modal-body">
                <div class="alert alert-danger" ng-if="vm.errors.hasErrors">{{ 'user.There was an error in a form' | translate }}</div>
                <div class="alert alert-notify">{{ 'user.To continue, you must accept our terms and conditions' | translate }}</div>
                <activate errors="vm.errors" form="vm.form" company-terms="vm.companyTerms"></activate>
            </div>
            <div class="modal-footer">
                <ul class="actions01">
                    <li class="primary"><button class="btn main" type="submit">{{ 'user.Continue' | translate }}</button></li>
                    <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'user.Cancel' | translate }}</button></li>
                </ul>
            </div>
        </form>
    `
})
export default class {
    constructor ($state, UserResource, AuthService, TokenService) {
        this.$state = $state;
        this.UserResource = UserResource;
        this.AuthService = AuthService;
        this.TokenService = TokenService;
        this.form = {};
        this.errors = {};
    }

    save () {
        this.UserResource
            .activateAccount(this.form)
            .$promise
            .then(() => {
                const companySlug = this.TokenService.getCompanySlug();
                this.$state.go('home', { company: companySlug });
                this.close();
            })
            .catch((response) => {
                this.errors = response.data.reduce((original, error) => {
                    original[error.field] = error.message;
                    return original;
                }, {});
                this.errors.hasErrors = true;
            });
    }
    cancel () {
        const companySlug = this.TokenService.getCompanySlug();

        this.AuthService.logout();
        this.close();
        this.$state.go('home', { company: companySlug });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/account/activate/index.js